import React from "react"
import Modal from "@components/modal"
import BlockHero from "@components/common/blockHero"
import ModalActuacionContent from "@components/common/modalActuacionContent"
import Image from "@images/actuacion/modal/anticipamos/anticipamos.png"
import Virtual from "@images/actuacion/modal/anticipamos/virtual.png"

import Icon3 from "@images/icons/es/cert-icon-03.png"
import Icon9 from "@images/icons/es/cert-icon-09.png"
import Icon17 from "@images/icons/es/cert-icon-17.png"
import Convocatoria from "@images/actuacion/modal/anticipamos/convocatoria.png"
import Alfonso from "@images/actuacion/modal/anticipamos/alfonso.png"
import BtnVer from "@components/common/btnVer"
import ChangeModalBtn from "@components/common/changePageBtn"

const Anticipamos = () => {
  return (
    <Modal title="OUR PERFORMANCE IN 2020">
      <div className="mainModal-container">
        <div className="element">
          <BlockHero>
            <div className="title">Anticipating</div>
            <div className="subtitle">the needs for the future</div>
            <div className="description">
              Digital transformation is one of the key pillars of Mutua
              Universal's growth strategy as a driving force for the development
              of new services and ongoing improvement in the health care
              provided to associated companies and protected workers.
            </div>
          </BlockHero>
        </div>
        <div className="element anticipamos">
          <ModalActuacionContent>
            <div className="row">
              <div className="image">
                <img src={Image} alt=""></img>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="sideA">
                  <div className="title">Speeding up the digital agenda</div>
                  <div className="subtitle">
                    The Digital Transformation Office is in charge of promoting
                    the digital agenda in accordance with Mutua Universal's
                    strategy. The actions the team carried out in 2020 to meet
                    the new demands that arose during the pandemic demonstrate
                    the cross-cutting, multidisciplinary nature of their work.
                  </div>
                  <div className="list">
                    <ul>
                      <li>
                        Adaptation of platforms and services for the management
                        of special benefits for the self-employed.
                      </li>
                      <li>Launch of the Teleconsultation service.</li>
                      <li>
                        Adaptation of IT systems to include extra information
                        relating to COVID-19 processes.
                      </li>
                      <li>
                        Development of collaborative solutions (Teams and Zoom)
                        to maintain remote communication between the Company's
                        employees.
                      </li>
                      <li>
                        Continued development of the Lynx artificial
                        intelligence project.
                      </li>
                      <li>
                        Development of the digital office through electronic
                        notification and the digital certificate service.
                      </li>
                      <li>
                        Digitalisation and improvement of healthcare procurement
                        processes.
                      </li>
                    </ul>
                  </div>
                  <div className="number">
                    <span>91,000</span>
                    <span>
                      pre-applications for benefits for self-employed workers
                      managed using RPA processes
                    </span>
                  </div>
                </div>
                <div className="sideB">
                  <div className="image">
                    <img src={Virtual} alt=""></img>
                  </div>
                  <div className="descritpion">
                    <strong>
                      Application of virtual reality to stress management.
                    </strong>{" "}
                    In 2020 we carried out a proof of concept study, the results
                    of which led to the design and development of two
                    experiments based on virtual environments.
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="title">SDGS WITH DIRECT IMPACT</div>
              <div className="icons">
                <img src={Icon3} alt=""></img>
                <img src={Icon9} alt=""></img>
                <img src={Icon17} alt=""></img>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="side">
                  <div className="title">
                    Commitment to artificial intelligence for continuous service
                    improvement
                  </div>
                  <div className="description">
                    One of the objectives of the 2018-20 Strategic Plan already
                    in place is the introduction of artificial intelligence and
                    predictive analysis to optimise contingency management. This
                    commitment allows us to collect our own data and to apply
                    these technologies to improve other services, thereby
                    positioning Mutua Universal as a data-driven company.
                  </div>
                </div>
                <div className="side">
                  <div className="title">
                    <div className="image">
                      <img src={Alfonso} alt=""></img>
                    </div>
                    <span>
                      “Technologies such as artificial intelligence and machine
                      learning help healthcare professionals to take decisions
                      so that they can focus on the personal interaction with
                      the patient.”
                    </span>
                  </div>
                  <div className="description">
                    <span>Alfonso Valencia</span>, Director of the Department of
                    Life Sciences at the Barcelona Supercomputing Centre and
                    Director of the National Institute of Bioinformatics.
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="content">
                  <div className="image">
                    <img src={Convocatoria} alt=""></img>
                  </div>
                  <div className="top">
                    <div className="title">
                      Call for entries for the 6th Innovation and Health Awards
                    </div>
                    <div className="description">
                      <p>
                        Artificial intelligence was also the protagonist at the
                        sixth edition of the Innovation and Health Awards, held
                        virtually in November. The event included a presentation
                        by Dr. Alfonso Valencia on the medicine of the future in
                        times of COVID-19.
                      </p>
                      <p>
                        Social distancing measures forced us to suspend the
                        awards ceremony for the winners of the fifth edition,
                        initially scheduled for March 2021.
                      </p>
                    </div>
                    <div className="btnVer">
                      <a
                        rel="noreferrer"
                        href="https://premios.mutuauniversal.net/es/"
                        target="_blank"
                      >
                        <BtnVer name="See more"></BtnVer>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalActuacionContent>
        </div>
        <div className="changeBtn">
          <ChangeModalBtn />
        </div>
      </div>
    </Modal>
  )
}

export default Anticipamos
